import styles from './style.module.scss';
import { getIconUrl } from '../../lib/cdn-icon-url';
import typicalIcon from '../../assets/svg/typical-icon.svg';
import { ImgComponent } from '../components/img-component';

interface IProps {
  readonly typicalApplicationsConfig: {
    readonly iconUrl: string;
    readonly title: string;
    readonly desc: string;
  };
}

export const ProductsTypicalApplications = (props: IProps) => {
  return (
    <div className={styles.productsTypicalApplicationsItemBox}>
      <div className={styles.typicalApplicationsItemLeft}>
        <ImgComponent
          key={props.typicalApplicationsConfig?.iconUrl || ''}
          url={getIconUrl(props.typicalApplicationsConfig?.iconUrl || '')}
          className={styles.typicalApplicationsItemIcon}
        />
        <img
          src={typicalIcon}
          className={styles.typicalApplicationsItemRightIcon}
        />
      </div>
      <div className={styles.typicalApplicationsItemRight}>
        <div className={styles.typicalApplicationsItemTitle}>
          {props.typicalApplicationsConfig?.title || ''}
        </div>
        <div className={styles.typicalApplicationsItemDesc}>
          {props.typicalApplicationsConfig?.desc || ''}
        </div>
      </div>
    </div>
  );
};
